<template>
  <b-modal
    v-model="show"
    centered
    size="md"
    :no-close-on-backdrop="submitting"
    :no-close-on-esc="submitting"
    @hidden="onHidden"
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Set this file to pending?</h3>
    </template>

    <p class="mb-3">This will reset the file's company approval to pending.</p>

    <b-form-group
      label="Comment"
      label-for="pending-comment"
      label-class="font-weight-bold"
    >
      <template #label>
        Comment <span class="text-secondary small">(optional)</span>
      </template>
      <b-form-textarea
        id="pending-comment"
        v-model="reason"
        rows="4"
        max-rows="8"
        placeholder="Add an optional note for setting this file to pending"
        :state="reasonState"
        :disabled="submitting"
        aria-describedby="pending-comment-feedback"
      />
      <b-form-invalid-feedback id="pending-comment-feedback">
        {{ errorMessage }}
      </b-form-invalid-feedback>
    </b-form-group>

    <template #modal-footer>
      <div class="d-flex justify-content-end" style="gap: 12px">
        <b-button
          variant="secondary"
          :disabled="submitting"
          @click="closeDialog"
        >
          Cancel
        </b-button>
        <b-button variant="warning" :disabled="submitting" @click="onConfirm">
          <b-spinner v-if="submitting" small label="Submitting" />
          <span v-else>Set to pending</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'PendingFileModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      reason: '',
      submitting: false,
      errorMessage: '',
    }
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.closeDialog()
      },
    },
    trimmedReason() {
      return (this.reason || '').trim()
    },
    reasonState() {
      if (this.errorMessage) return false
      return null
    },
  },

  watch: {
    showModal(val) {
      if (val) {
        this.reason = ''
        this.errorMessage = ''
        this.submitting = false
      }
    },
  },

  methods: {
    closeDialog() {
      if (this.submitting) return
      this.$emit('close')
    },

    onHidden() {
      this.reason = ''
      this.errorMessage = ''
      this.submitting = false
    },

    onConfirm() {
      if (this.submitting) return
      this.submitting = true
      this.errorMessage = ''
      this.$emit('confirm', {
        reason: this.trimmedReason,
        done: (err) => {
          this.submitting = false
          if (err) {
            const payload = err && err.response && err.response.data
            if (err && err.response && err.response.status === 422) {
              this.errorMessage =
                (payload && (payload.message || payload.error)) ||
                'Please check the comment and try again.'
              return
            }
            this.errorMessage =
              (payload && payload.message) ||
              (err && err.message) ||
              'Could not set file to pending.'
            return
          }
          this.$emit('close')
        },
      })
    },
  },
}
</script>
